import { useContext } from 'react';
import { EntityExplorerContext } from './EntityExplorerContext';

/**
 * Custom hook to access EntityExplorer context
 *
 * @throws {Error} If used outside of EntityExplorerProvider
 * @returns EntityExplorerContextValue with drawer state and control functions
 *
 * @example
 * ```tsx
 * const { openDrawer, closeDrawer, drawers } = useEntityExplorer();
 *
 * // Open a customer drawer
 * openDrawer('customer', '123', 'John Doe');
 *
 * // Close a specific drawer
 * closeDrawer(drawerId);
 * ```
 */
export const useEntityExplorer = () => {
  const context = useContext(EntityExplorerContext);

  if (context === undefined) {
    throw new Error('useEntityExplorer must be used within an EntityExplorerProvider');
  }

  return context;
};
